export default "__VITE_ASSET__CPddQ78W__"